import { IInstallment } from "@/types/installment.type";
import { ContractFinesType, PaymentInfo, NegotiationReactivationType, ConvertDepositType, PaymentFormValues } from "../../types/payment.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";


const API_URL = `${import.meta.env.VITE_API_URL}/payments`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export function getRenterPayments(renterId) {
  const url = `${API_URL}/${renterId}/payments`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo[]>
  >;
}

export function getRenterPaymentsAsaas(renterId) {
  const url = `${API_URL}/asaas/${renterId}`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo[]>
  >;
}

export function getPaymentsById(billingId: string) {
  const url = `${API_URL}/${billingId}`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}




export function getRenterInstallment(renterId: string) {
  const url = `${API_URL}/${renterId}/installment`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IInstallment[]>
  >;
}

export function syncInstallmentsAsaas(renterId: string) {
  const url = `${API_URL}/sync-installments/${renterId}`;
  const options = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}

export function createContractFines(data: ContractFinesType) {
  const url = `${API_URL}/contract-fines`;
  const options = {
    method: "POST",
    skipUFParam: true,
    skipUFHeader: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo[]>
  >;
}

export function weekInstallments(data: PaymentFormValues) {
  const url = `${API_URL}/week-installments`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo[]>
  >;
}
export function createReactivationBilling(data: NegotiationReactivationType) {
  const url = `${API_URL}/billing-reactivation`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo[]>
  >;
}
export function convertDeposit(dataDepositConvert: ConvertDepositType) {
  const url = `${API_URL}/convert-deposit`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dataDepositConvert),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo[]>
  >;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any 
export function restorePayment(billingId: string, data: any) {
  const url = `${API_URL}/${billingId}/restore`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any 
export function adjustSubscription(billingId: string, data: any) {
  const url = `${API_URL}/${billingId}/adjust`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}


export function updatedPayment(billingId, paymentData) {
  const url = `${API_URL}/${billingId}/edit`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(paymentData),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function updateAsassPayment(data: any) {
  const url = `${API_URL}/update-payday`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;

  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deletePayment(billingId: string, data: any) {
  const url = `${API_URL}/${billingId}/delete`;
  const options = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<PaymentInfo>
  >;
}
